<template>
  <div>
    <vx-card>
      <List :subjectPermission="subjectPermission"></List>
    </vx-card>
  </div>
</template>

<script>
import List from "./ListTags";

export default {
  data() {
    return {
      subjectPermission: "Tags",
    };
  },
  methods: {},
  components: {
    List,
  },
};
</script>
